import { useTranslate } from 'react-admin';

const useTranslation = (i18nPath, key) => {
  const translate = useTranslate();
  return translate(`${i18nPath}.${key}`);
};

export default useTranslation;
